// extracted by mini-css-extract-plugin
export default {"container":"eK-z","topReviewHeading":"fK-z","criticalReview":"gK-z","favorableReview":"hK-z","vsSeparator":"iK-z"};